import { Box, Card, Typography, LinkButton } from "@bca/ui-library";
import styled from "styled-components";
import analytics from "./common/analytics/analytics";
import { IEventPushable } from "./common/analytics/analytics.types";
import {
  layout,
  LayoutProps,
  flexbox,
  FlexboxProps,
  typography,
  TypographyProps,
  space,
  ColorProps,
  SpaceProps,
} from "styled-system";

import LotNotFoundSVG from "./icons/LotNotFoundSVG";
import { useRouter } from "next/router";
import getStockAlertLink from "./getStockAlertLink";

interface StyledProps
  extends FlexboxProps,
    LayoutProps,
    ColorProps,
    TypographyProps,
    SpaceProps {
  children?: React.ReactNode;
}

const CardContainer = styled(Card)<StyledProps>`
  ${layout}
  ${flexbox}
`;

const Paragraph = styled.p<StyledProps>`
  ${layout}
  ${flexbox}
  ${typography}
  ${space}
`;

const StockAlert = () => {
  const router = useRouter();
  const allQueryStrings = router.query;

  const link = getStockAlertLink(allQueryStrings);

  const pushStockAlertAnalytics = () => {
    analytics.push<IEventPushable>({
      event: {
        name: "click",
        category: "link",
        label: "create-stock-alert",
        action: "start",
        section: "footer",
      },
    });
  };

  return (
    <CardContainer
      minHeight="136px"
      height="auto"
      display="flex"
      flexDirection={{
        mobile: "column",
        tablet: "column",
        desktop: "row",
      }}
      flexWrap="wrap"
      justifyContent="center"
      alignItems="center"
      width="100%"
      marginX="0"
      marginY="50px"
      paddingRight={{ mobile: "25px", tablet: "25px", desktop: "35px" }}
      paddingLeft={{ mobile: "25px", tablet: "25px", desktop: "35px" }}
      paddingTop={{ mobile: "40px", tablet: "40px", desktop: "35px" }}
      paddingBottom={{ mobile: "40px", tablet: "40px", desktop: "35px" }}
    >
      <LotNotFoundSVG
        width="56px"
        height="42px"
        minWidth="56px"
        marginBottom={{ mobile: "15px", tablet: "15px", desktop: 0 }}
      />
      <Box
        flex="3"
        display="flex"
        justifyContent="center"
        flexDirection="column"
        alignItems={{
          mobile: "center",
          tablet: "center",
          desktop: "flex-start",
        }}
        marginLeft={{
          mobile: 0,
          tablet: 0,
          desktop: "35px",
        }}
        marginRight={{
          mobile: 0,
          tablet: 0,
          desktop: "5px",
        }}
      >
        <Typography
          color="footer-blue"
          variant="h5"
          my="0"
          css={`
            margin-bottom: 12px;
            min-width: 281px;
          `}
        >
          Can't find the vehicle you want?
        </Typography>
        <Paragraph
          color="grey-blue"
          margin="0"
          textAlign={{ mobile: "center", tablet: "center", desktop: "left" }}
        >
          Create a stock alert and we will notify you when it’s available.
        </Paragraph>
      </Box>
      <LinkButton
        marginTop={{ mobile: "25px", tablet: "25px", desktop: 0 }}
        css={`
          font-size: 16px;
          flex: 1;
          @media screen and (max-width: 939px) and (min-width: 769px) {
            margin-top: 25px;
          }
        `}
        text="Create a Stock Alert"
        variant="secondary"
        link={link.toString()}
        onClick={pushStockAlertAnalytics}
        paddingX={2}
        paddingY="10px"
        minWidth="170px"
        maxWidth="200px"
        height="42px"
        textAlign="center"
      />
    </CardContainer>
  );
};

export default StockAlert;
